angular
    .module('app')
    .component('schools', {
        templateUrl: '/templates/pages/schools/schools.html',
        controller: 'SchoolsController',
        controllerAs: 'vm',
    });